import script from "./EditMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./EditMenu.vue?vue&type=script&setup=true&lang=js"

import "./EditMenu.vue?vue&type=style&index=0&id=d2aea5a4&scoped=true&lang=css"

import exportComponent from "E:\\Java\\GongJu\\idea\\job\\job_slcj\\job_vue_boot\\job_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2aea5a4"]])

export default __exports__